import React from 'react'

import pinStatus from '../../helpers/pin-status'

import HistoryListContainer from '../../containers/histories/history-list-container'
import PinLoadingIndicator from './pin-loading-indicator'

import ImageZoom from 'react-medium-image-zoom'

import { Details, Row, Block } from '../../components/details/details'
import { ButtonRow, Button } from '../buttons'
import { Tabs, Tab, TabList, TabPanel } from 'react-tabs'

export default ({
  children,
  loading,
  pin,
  area,
  latestHistory,

  markAsResolved,

  location,
  onTabSelect,
  selectedTab,
  userForHistory
}) => (
  <PinLoadingIndicator loading={loading}>
    {() =>
      <div className='pin-details'>
        <Details actionType='edit' actionLink={`${location.pathname}/edit`}>
          <Row>
            <Block title='room'>
              <p>{area.name}</p>
            </Block>
            <Block title='current status'>
              <p>{pinStatus(pin.status)}</p>
            </Block>
          </Row>
          <Row>
            <Block title='notes'>
              <p>{pin.description || '—'}</p>
            </Block>
          </Row>
          <Row>
            <Block title='last updated'>
              <p>
                {latestHistory
                  ? (latestHistory.createdAt.format('MMMM Do, YYYY'))
                  : '—'}
              </p>
            </Block>
            <Block title='actions'>
              <ButtonRow>
                <Button small to={`${location.pathname}/edit`}>Update</Button>
                <Button
                  small
                  onClick={() => !pin.isResolved && markAsResolved()}
                  disabled={pin.isResolved}
                >
                  {pin.isResolved
                    ? '✓ Resolved'
                    : 'Mark as Resolved'}
                </Button>
              </ButtonRow>
            </Block>
          </Row>
        </Details>

        <Tabs className='tabs' selectedIndex={selectedTab} onSelect={onTabSelect}>
          <TabList>
            <Tab>Images</Tab>
            <Tab>History</Tab>
          </TabList>

          <TabPanel>
            <div className='pin-images'>
              <div className='pin-image'>
                <h5>Before</h5>
                {pin.beforeImage && pin.beforeImage.url
                  ? (<ImageZoom image={{ src: pin.beforeImage.url }} />)
                  : (<p className='no-content'>No before image provided.</p>)
                }
              </div>

              <div className='pin-image'>
                <h5>After</h5>
                {pin.afterImage && pin.afterImage.url
                  ? (<ImageZoom image={{ src: pin.afterImage.url }} />)
                  : (<p className='no-content'>No after image provided.</p>)
                }
              </div>
            </div>
          </TabPanel>

          <TabPanel>
            <HistoryListContainer pinId={pin.id} />
          </TabPanel>
        </Tabs>

        {children}
      </div>
    }
  </PinLoadingIndicator>
)



// WEBPACK FOOTER //
// ./src/components/pins/pin-details.js